import { Chip, styled } from '@mui/material';

import type { StyledChipProps } from './types';

export const StyledChip = styled(Chip, {
  shouldForwardProp: prop =>
    prop !== '$textColor' && prop !== '$bgColor' && prop !== '$fontSize',
})<StyledChipProps>(({ $textColor, $bgColor, $fontSize }) => ({
  color: $textColor,
  backgroundColor: $bgColor,
  fontWeight: 700,
  fontSize: $fontSize,
}));
